// import { useRef } from "react";

import { useEffect, useState } from "react";
import AboutMe from "../AboutMe/AboutMe";
import Heading from "../Headings/Heading";
import Heading2 from "../Headings/Heading2";
// import LatestProjectDisplay from "../Projects/LatestProjectDisplay";
import "./TimeLine.css";
import TimelineParent from "./TimelineParent";
// import ImageSlider from "../Parallax Slider/ImageSlider";
import RenderProjects from "../Projects/ParallaxSliderRender";
import IconCloud from "../../magicui/SkillCloud/SkillCloud.tsx";

const TimeLine = () => {
    const [mobileScreen, setMobileScreen] = useState(false);
    useEffect(() => {
        const screenWidth = window.innerWidth;
        if (screenWidth < 500) {
            setMobileScreen(true);
        } else {
            setMobileScreen(false);
        }
        // console.log(screenWidth < 400, settings);
    }, [mobileScreen]);
    // const sectionsRef = useRef(null);
    return <section className="timeline-section"><div className="timeline">
        <div className="timeline-initial">
        </div>
        {/* <TimelineParent ref={sectionsRef} > */}
        {/* {mobileScreen ? <hr /> : ''} */}
        {/* <TimelineParent ref={sectionsRef} > */}
        <TimelineParent className='timeline-section-alter'>
            <Heading2 id='skills'>About NAVEEN</Heading2>
            <AboutMe />
        </TimelineParent>
        <TimelineParent>
            <Heading id='project-latest'>THE LATEST</Heading>
            {/* <LatestProjectDisplay /> */}
            <RenderProjects />
        </TimelineParent>
        <TimelineParent>
            <IconCloud />
        </TimelineParent>
        <TimelineParent>
            {/* <OrbitingCirclesWhyMe /> */}
        </TimelineParent>
    </div>
    </section>
}

export default TimeLine;
